const getters = {
  // Example
  isLoading: (state) => {
    return state.isLoading;
  },
};

export default getters; 
